import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS, API_URLS_ENTITY } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
interface IUseFetchMatterActivities {
  startTime?: string;
  dueTime?: string;
  relations?: string[];
  sortBy?: string[];
  extraFilters?: Record<string, string | number | undefined>;
  pageSize?: number;
  search?: string;
  fields?: string[];
  id?: string;
  enabled: boolean;
}
export const useFetchMatterActivities = (params: IUseFetchMatterActivities) => {
  const fetchMatterActivities = async ({ pageParam = 1 }) => {
    const {
      relations: matterActivitiesRelations,
      extraFilters: filters,
      pageSize,
      id,
      ...rest
    } = params;
    const queryString = new URLSearchParams(
      Object.keys(rest)?.length ? toQueryString(rest as QueryParamObject) : '',
    );

    Object.entries(filters ?? {}).forEach(([key, value]) => {
      if (value) {
        queryString.append(`filter.${key}`, String(value));
      }
    });

    (matterActivitiesRelations ?? []).forEach((rel) => queryString.append('relations', rel));

    queryString.append('page', String(pageParam));
    queryString.append('limit', String(pageSize));
    try {
      return await get(
        `${API_URLS_ENTITY.MATTER}/${id}${API_URLS.TASKS_LIST}?${queryString.toString()}`,
      );
    } catch (error) {
      console.error('Error fetching Matter Activities:', error);
      throw new Error(
        (error as { message: string }).message || 'Failed to fetch matter activities',
      ); // Force error throwing
    }
  };

  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  } = useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['matter-activities-list', params],
    queryFn: fetchMatterActivities,
    enabled: params.enabled,
    getNextPageParam: (lastPage, allPages) => {
      const totalCount = lastPage?.meta?.totalItems ?? 0;
      const fetchedCount = allPages.flatMap((page) => page.data).length;
      return fetchedCount < totalCount ? allPages.length + 1 : undefined;
    },
  });
  return {
    data: data?.pages.flatMap((page) => page.data) ?? [],
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  };
};
